import { useState } from "react";

/**
 * Custom hook for managing password input visibility.
 * Replaces direct DOM manipulation with React state.
 *
 * @returns {{ type: string, visible: boolean, toggle: Function }}
 *          `type` determines `<input type="...">` (text or password).
 *          `visible` provides the raw boolean boolean state.
 *          `toggle` toggles the visibility state.
 */
export const usePasswordToggle = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(prev => !prev);
  return { type: visible ? "text" : "password", visible, toggle };
};
